import React from 'react';
import { ROOM_TYPES, type RoomType } from '@/lighting-app/data/lightingStandards';

interface StepRoomTypeProps {
  selected: RoomType | null;
  onSelect: (room: RoomType) => void;
}

export default function StepRoomType({ selected, onSelect }: StepRoomTypeProps) {
  return (
    <div className="slide-up">
      <div className="text-center mb-8">
        <h2 className="text-2xl lg:text-3xl font-bold text-foreground mb-2">
          ما نوع المكان الذي تريد تصميم إضاءته؟
        </h2>
        <p className="text-muted-foreground">اختر نوع المكان لتحديد مستوى الإضاءة المناسب تلقائياً</p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 gap-4">
        {ROOM_TYPES.map((room) => (
          <button
            key={`room-type-${room.id}`}
            onClick={() => onSelect(room)}
            className={`room-grid-item p-4 rounded-2xl border-2 text-center transition-all duration-200 cursor-pointer ${
              selected?.id === room.id
                ? 'border-primary bg-accent shadow-primary'
                : 'border-border bg-card hover:border-primary/40 hover:bg-accent/50'
            }`}
          >
            <div className="text-3xl mb-3">{room.icon}</div>
            <div className="font-bold text-foreground text-sm mb-1">{room.nameAr}</div>
            <div className="text-xs text-muted-foreground font-tabular">{room.recommendedLux} Lux</div>
          </button>
        ))}
      </div>

      {selected && (
        <div className="mt-6 p-4 bg-accent rounded-xl border border-primary/20 fade-in">
          <div className="flex items-center gap-3">
            <span className="text-2xl">{selected.icon}</span>
            <div>
              <div className="font-bold text-foreground">{selected.nameAr}</div>
              <div className="text-sm text-muted-foreground">{selected.description}</div>
            </div>
            <div className="mr-auto text-right">
              <div className="text-xs text-muted-foreground">الإضاءة الموصى بها</div>
              <div className="font-bold text-primary font-tabular">{selected.recommendedLux} Lux</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}